import React,{ useState } from 'react';
import { useForm } from 'react-hook-form';
import Modal from 'react-modal';
import { CustomInput } from '../../Containers/RegisterTransporter/style'
import {StyledTextArea } from '../../Containers/PasserCommande/PasserCommande.styles'
import {demandeTransfert} from '../../api/commande'
import { useSelector } from 'react-redux'
import  toast from 'react-hot-toast'
import { useTranslation } from 'react-i18next';

const AjouterDemandeTransfert = ({ modalIsOpenTransfret, setModalIsOpenTransfret, commande }) => {
    const { register, handleSubmit, setValue, reset, formState: { errors } } = useForm();
    const [updateLoading, setUpdateLoading] = useState(false);
    const user = useSelector(state => state.auth.user)
	const token = useSelector((state) => state.auth.token);
const {t} = useTranslation();
    const onSubmit = async (data) => {
        setUpdateLoading(true);
        try {
            if(Number(data.distanceParcourue)>commande.distance){
                toast.error(`${t("distance_traveled_err2")} ${commande.distance} km`, {
                    style: {
                        fontFamily: 'Montserrat',
                    },
                });
                return 
            }
            data = {
                ...data,
                transporteurId: user._id,
                commandeId: commande._id
            };

            await demandeTransfert(data,token)	
            toast.success(t("success_transfert_request"), {
                    style: {
                        fontFamily: 'Montserrat',
                    },
                });

        } catch (error) {
            console.error('Erreur lors de la demande de transfert', error);
            toast.error(t("transfer_request_err" ), {
                style: {
                    fontFamily: 'Montserrat',
                },
            });
        } finally {
            setUpdateLoading(false);
            setModalIsOpenTransfret(false);
            reset()
        }
    };
    
    return (
        <Modal
            isOpen={modalIsOpenTransfret}
            style={{
                overlay: {
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.45)',
                },
                content: {
                    top: '50%',
                    left: '50%',
                    right: 'auto',
                    bottom: 'auto',
                    marginRight: '-50%',
                    transform: 'translate(-50%, -50%)',
                    borderRadius: 19,
                    background: '#E4EAF0',
                    height: '480px',
                    width: '600px',
                },
            }}
            contentLabel='Example Modal'
        >
            <div
                style={{
                    width: '100%',
                    fontFamily: 'Montserrat',
                    display: 'flex',
                    flexDirection: 'column',
                    fontSize: 15,
                    textAlign: 'left',
                    color: '#838EAB',
                }}
            >
                <div
                    style={{
                        color: '#51C7F2',
                        fontSize: 30,
                        marginBottom: '1rem',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                  {t("transfer_request")}
                </div>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div style={{ marginLeft: '2rem', marginRight: '2rem' }}>
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                width: '100%',
                                marginRight: '1rem',
                            }}
                        >
                            <span
                                style={{
                                    marginBottom: '1rem',
                                    color: 'black',
                                    fontSize: 14,
                                }}
                            >
                                {t("distance_traveled")}
                            </span>
                            <CustomInput
                                type='number'
                                placeholder=''
                                min={1}
                                {...register('distanceParcourue', { required: t("distance_traveled_err1") })}
                            />
                            {errors.distanceParcourue && <span style={{ color: 'red', marginTop: '0.5rem' }}>{errors.distanceParcourue.message}</span>}
                        </div>
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                width: '100%',
                                marginRight: '1rem',
                                marginTop: '1rem',
                            }}
                        >
                            <span
                                style={{
                                    marginBottom: '1rem',
                                    color: 'black',
                                    fontSize: 14,
                                }}
                            >
                                {t("note")}
                            </span>
                            <StyledTextArea
                                type='text'
                                rows={4}
                                placeholder=''
                                {...register('remarque', { required: t("note_err")})}
                            />
                            {errors.remarque && <span style={{ color: 'red', marginTop: '0.5rem' }}>{errors.remarque.message}</span>}
                        </div>
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: '1rem',
                            marginTop: '1rem',
                        }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                            }}
                        >
                            <button
                                type='submit'
                                disabled={updateLoading}
                                style={{
                                    background: '#50F5A9',
                                    border: 'none',
                                    cursor: 'pointer',
                                    color: 'white',
                                    fontFamily: 'Montserrat',
                                    padding: '1rem 2rem',
                                    borderRadius: 6,
                                }}
                            >
                                {updateLoading ? (
                                    <div className='loader'></div>
                                ) : (
                                     t("add")
                                )}
                            </button>
                            <button
                                type='button'
                                onClick={() => {
                                    setModalIsOpenTransfret(false);
                                    reset();
                                }}
                                style={{
                                    background: 'red',
                                    border: 'none',
                                    cursor: 'pointer',
                                    color: 'white',
                                    marginLeft: '1rem',
                                    fontFamily: 'Montserrat',
                                    padding: '1rem 2rem',
                                    borderRadius: 6,
                                }}
                            >
                                {t("cancel")}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </Modal>
    );
};

export default AjouterDemandeTransfert;